// store.ts
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import alertReducer from './alertSlice';
import authReducer from './authSlice';
import businessNetworkReducer from './businessNetworkSlice';
import clientCompanyTypesReducer from './clientCompanyTypesSlice';
import clientConfigurationReducer from './clientConfigSlice';
import conversionRatesReducer from './conversionRatesSlice';
import documentProfileReducer from './documentProfileSlice';
import entityRecordReducer from './entityRecordSlice';
import notificationReducer from './notificactionSlice';
import purchaseOrderModalReducer from './purchaseOrderModalSlice';
import tenderModalReducer from './tenderModalSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  businessNetwork: businessNetworkReducer,
  notification: notificationReducer,
  clientConfiguration: clientConfigurationReducer,
  clientCompanyTypes: clientCompanyTypesReducer,
  conversionRates: conversionRatesReducer,
  tenderModal: tenderModalReducer,
  documentProfile: documentProfileReducer,
  entityRecord: entityRecordReducer,
  purchaseOrderModal: purchaseOrderModalReducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);

// De-comment this line to log the state of the persistor
// persistor.subscribe(() => {
//   const state = persistor.getState();
//   console.log('[Persistor] State:', state);
//   // Puedes detectar si ya se rehidrató por ejemplo
// });
